import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import AdminRoutes from '../admin/components/AdminRoutes';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/admin/*" element={<AdminRoutes />} />
      <Route path="/*" element={<MainLayout />} />
    </Routes>
  );
};

export default AppRoutes; 